const HOSTED_FORM_FALLBACK_HEIGHT = "900";

export function observeHostedPaymentFrame(container: HTMLElement): () => void {
  const prepareFrames = () => {
    container.querySelectorAll("iframe").forEach((frame) => {
      // Zuora can start at zero before sending its automatic resize. Keep its
      // native submit reachable if resizing is unavailable, including challenges.
      if (Number(frame.getAttribute("height")) <= 0)
        frame.setAttribute("height", HOSTED_FORM_FALLBACK_HEIGHT);
      if (frame.getAttribute("scrolling") === "no")
        frame.setAttribute("scrolling", "auto");
    });
  };
  const observer = new MutationObserver(prepareFrames);
  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["height", "scrolling"],
  });
  prepareFrames();
  return () => observer.disconnect();
}
